import ActivityTimeline, {
  ActivityEvent,
  TrackerItemEventType,
} from "@/components/activity-timeline";
import {
  TrackerColumn,
  TrackerItemEvent,
} from "@/v2/entities/tracker/Tracker.model";
import { Flex, Text } from "@radix-ui/themes";
import { useMemo } from "react";

function convertDataToActivityEvents(
  data: TrackerItemEvent[],
  convertColumnIdToName: (columnId: string) => string
): ActivityEvent[] {
  return data
    .filter((event: TrackerItemEvent) => event.type !== "stage_change")
    .map((event: TrackerItemEvent) => {
      let eventType: TrackerItemEventType;
      let trackerDetails: {
        trackerId?: string;
        toColumn?: string;
        toStage?: string;
        toStageReason?: string;
        toStageDescription?: string;
        comment?: string;
      } = {};

      switch (event.type) {
        case "captured_by_tracker":
          eventType = "Captured by Tracker";
          trackerDetails.trackerId = event.value;
          break;

        case "column_change":
          eventType = "Column Changed";
          const columnChangeEvent = JSON.parse(event.value || "{}");
          trackerDetails.toColumn = convertColumnIdToName(
            columnChangeEvent.columnId
          );
          break;
        case "comment":
          eventType = "Comment Added";
          trackerDetails.comment = event.value;
          break;
        default:
          eventType = "Tracker Event";
      }

      const activityEvent: ActivityEvent = {
        type: eventType,
        timestamp: event.createdAt?.toString() || "",
        trackerDetails,
      };
      return activityEvent;
    });
}

export function TrackerItemAudit({
  trackerItemEvents,
  trackerColumns,
}: {
  trackerItemEvents: TrackerItemEvent[];
  trackerColumns: TrackerColumn[];
}) {
  const convertColumnIdToName = useMemo(
    () => (columnId: string) => {
      const column = trackerColumns.find((c) => c.id === columnId);
      return column?.name || "unknown";
    },
    [trackerColumns]
  );

  const activityEvents = useMemo(() => {
    return convertDataToActivityEvents(
      trackerItemEvents,
      convertColumnIdToName
    );
  }, [trackerItemEvents, convertColumnIdToName]);

  return (
    <Flex direction={"column"} gap={"2"} p={"4"}>
      <Text size={"2"}>Tracker Activity</Text>
      <ActivityTimeline events={activityEvents} />
    </Flex>
  );
}
